module.exports = __webpack_public_path__ + "img/anssica.efebd541.jpg";